jQuery(window).on('load', function () {

    var segments = location.pathname.split("/");

    var leaseTypes = {
        'full_services': 'Full Service',
        'gross': 'Gross',
        'modified_gross': 'Modified Gross',
        'nnn': 'NNN',
        'modified_net': 'Modified Net',
        'ground_lease': 'Ground Lease'
    };

    var unitDealStatus = {
        'available': 'Available',
        'off_market': 'Off Market',
        'closed': 'Closed',
        'under_contract': 'Under Contract'
    };

    if (isInArray('properties', segments)) {

        var initialize = function () {
            if (isInArray('overview', segments)) {
                setOverviewFields();
            } else if (isInArray('attachments', segments)) {
                TableController.Files.init();
            }

            setBreadcrumb();
        };

        var setBreadcrumb = function () {
            $(document).on('click', '.properties-next', function () {
                var form = $('#property-form');
                var status = form.find('[name="listing[status]"]').val();
                var listing_type = form.find('[name="listing[listing_type]"]').val();
                var old_status = form.find('[name="current_listing_status"]').val();

                if (status === 'CLOSED' || status === 'OFF_MARKET') {
                    if (isInArray('overview', segments)) {
                        setIndexes('additional-feature', 1);
                        setIndexes('suites-parcels', 11);
                        setIndexes('zonings', 4);
                    }

                    if(old_status === 'AVAILABLE' || old_status === 'UNDER_CONTRACT' || old_status.length === 0) {
                        getFollowUpQuestions(form, listing_type);
                    } else {
                        if(form.valid()) {
                            send(form);
                        }
                    }
                } else {
                    if(form.valid()) {
                        if (isInArray('overview', segments)) {
                            setIndexes('additional-feature', 1);
                            setIndexes('suites-parcels', 11);
                            setIndexes('zonings', 4);
                        }
                        if(form.valid()) {
                            send(form);
                        }
                    } else {
                        Materialize.toast('There are required fields to be filled. Check them before you proceed.', 2000, 'red');
                    }
                }
            });

            $(document).on('click', '.properties-previous', function () {
                var form = $('#property-form');
                window.location.href = property_url(form.attr('data-previous'));
            });

            $(document).on('click', '.properties-next-skip', function () {
                var form = $('#property-form');
                window.location.href = property_url(form.attr('data-next'));
            });
        };

        var getFollowUpQuestions = function(form, listing_type) {
            $("[name=sale_price]").val($("[name='comp[sale_price]']").val());
            $("[name=sale_price]").prev().addClass('active');

            $("[name=lease_rate]").val($("[name='comp[lease_rate]']").val());
            $("[name=lease_rate]").prev().addClass('active');

            $("[name=price_square_foot]").val($("[name='comp[price_square_foot]']").val());
            $("[name=price_square_foot]").prev().addClass('active');

            $("[name=term]").val($("[name='comp[term]']").val());
            $("[name=term]").prev().addClass('active');

            $("[name=concessions]").val($("[name='comp[concessions]']").val());
            $("[name=concessions]").prev().addClass('active');


            var followup = $('#follow-up-questions');
            followup.modal({dismissible:false});
            followup.modal('open');

            if(listing_type === 'sale') {
                followup.find("[data-ref=lease]").hide();
                followup.find("[data-ref=sale]").show();
            } else if(listing_type === 'lease') {
                followup.find("[data-ref=lease]").show();
                followup.find("[data-ref=sale]").hide();

            } else if(listing_type === 'sale_and_lease') {
                followup.find("[data-ref=lease]").show();
                followup.find("[data-ref=sale]").show();
            }

            $(".save-follow-up-questions").click(function(event){
                event.preventDefault();
                var followUpForm = $('#follow-up-questions-form');
                followUpForm.find('.currency').each(function (index, value) {
                    $(this).val($(this).maskMoney('unmasked')[0]);
                });
                var comp = followUpForm.serializeArray();
                followup.modal('close');
                send(form, comp);
            });
        };

        var setOverviewFields = function () {
            var utilSelect = $("#utilities_select");
            var utilInput = $('#utilities_other').parent('.input-field');

            // Allow 'Other' selection of Utilities
            var checkUtils = function (e) {
                if (e.val() === 'other') {
                    utilInput.removeClass('hide');
                } else if (!utilInput.hasClass('hide')) {
                    utilInput.addClass('hide');
                }
            };

            utilSelect.on('change', function () {
                checkUtils($(this));
            });

            $("[name='secondary_brokers[]']").change(_.debounce(function () {
                var select2Value = $(this).val();
                $("#secondary_broker").val(select2Value);
                $(this).material_select();
            }, 1500));

            //New Feature Entry Controller
            $(".additional-feature-entry").mouseenter(function () {
                if ($(".additional-feature-entry").length !== 1) {
                    $(this).find('i').toggleClass('hide');
                }
            }).mouseleave(function () {
                if ($(".additional-feature-entry").length !== 1) {
                    $(this).find('i').toggleClass('hide');
                }
            });

            $(document).on('click', '.delete-additional-feature', function () {
                if ($(".additional-feature-entry").length !== 1) {
                    $(this).closest('.additional-feature-entry').remove();
                }
            });

            $(document).on('click', '.add-additional-feature', function () {
                var income_source_row = $('.additional-feature-entry').last().clone();

                income_source_row.find("input").val("");

                $('.additional-feature-entry').last().after(income_source_row);

                income_source_row.mouseenter(function () {
                    if ($(".additional-feature-entry").length !== 1) {
                        $(this).find('i').toggleClass('hide');
                    }
                }).mouseleave(function () {
                    if ($(".additional-feature-entry").length !== 1) {
                        $(this).find('i').toggleClass('hide');
                    }
                });
            });

            $('form#property-form input,textarea,select').blur(function () {
                $(this).valid();
            });

            $('form#property-form select').change(function () {
                $(this).valid();
            });

            var listingTypeInput =  $('select[name="listing[listing_type]"]');

            listingTypeInput.change(function () {
                if ($(this).val() === 'sale') {
                    hideLease();
                    showSale();
                } else if ($(this).val() === 'lease') {
                    showLease();
                    hideSale();
                } else {
                    showLease();
                    showSale();
                }
            });

            if (listingTypeInput.val() === 'sale') {
                hideLease();
                showSale();
            } else if(listingTypeInput.val() === 'lease') {
                showLease();
                hideSale();
            } else {
                showLease();
                showSale();
            }

            function showLease() {
                $('.lease-listing-type').show();
                // $("input[name='listing[asking_price_psf]']").attr('required', 'required');
                // $("select[name='listing[payment_frequency]']").attr('required', 'required');
            }

            function hideLease() {
                $('.lease-listing-type').hide();
                // $("input[name='listing[asking_price_psf]']").removeAttr('required');
                // $("select[name='listing[payment_frequency]']").removeAttr('required');
            }

            function showSale() {
                $('.sale-listing-type').show();
                // $("input[name='listing[asking_price]']").attr('required', 'required');
            }

            function hideSale() {
                $('.sale-listing-type').hide();
                // $("input[name='listing[asking_price]']").removeAttr('required');
            }
        };

        var duplicateProperty = function (id) {
            startLoading('body');

            deleteConfirm(function (id) {
                $.ajax({
                    type: "POST",
                    url: $("body").data("base-url") + "properties/duplicate",
                    data: {
                        propertyId: id
                    },
                    success: function (responseText) {

                        stopLoading('body');
                        var property = JSON.parse(responseText);

                        if (property.id) {
                            TableController.Properties.refresh();
                        }

                        Materialize.toast(property.message, 2000);
                    },
                    failure: function () {
                        Materialize.toast("It was not possible to perform that action.", 2000);
                    }
                });
            }, id);
        };

        var send = function (form, comp) {
            unmaskFields();
            startLoading('body');

            var data = new FormData();

            var items = ViewManager.extractData(form);

            var hasSuiteParcelCheckbox = $("input[name='listing[has_suite_parcel]']");
            if (hasSuiteParcelCheckbox.length && !hasSuiteParcelCheckbox.prop('checked')) {
                items['listing[has_suite_parcel]'] = false;
            }

            for(var key in items) {
                if(items.hasOwnProperty(key)) {
                    data.append(key, items[key]);
                }
            }

            var files = FileController.getFileStore();
            var fileOrder = FileController.getFileOrder();

            for (var i = 0; i < files.length; i++) {
                if(files.hasOwnProperty(i) ) {
                    if(files[i].name !== undefined) {
                        data.append(files[i].name, files[i]);
                    }
                    data.append('file_order[]', JSON.stringify(fileOrder[i]));
                }
            }

            // Add comparative info to the form if property is being closed
            if(comp !== undefined && comp.length) {
                for(var j = 0; j < comp.length; j++) {
                    if(comp.hasOwnProperty(j) && comp[j] !== undefined) {
                        data.append(comp[j].name, comp[j].value);
                    }
                }
            }


            $.ajax({
                type: 'POST',
                url: form.attr('action'),
                data: data,
                processData: false,
                contentType: false,
                success: function (responseText) {
                    try {
                        stopLoading('body');
                        var response = JSON.parse(responseText);

                        if (response.status.localeCompare("success") === 0) {
                            saveToast();
                            window.location.href = createURI(form.attr('data-next'), response.id);
                        } else {
                            Materialize.toast(response.message,3000);
                        }
                    } catch (e) {
                       Materialize.toast("We could not save your property at the moment. Try again later.");
                    }
                }
            });
        };

        var createURI = function (nextStep, id, params) {
            if (nextStep) {
                var ret = [];
                for (var d in params) {
                    ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(params[d]));
                }
                if (id && params) {
                    return $("body").data("base-url") + "properties/" + nextStep + '/' + id + '?' + ret.join('&');
                } else if (id && !params) {
                    return $("body").data("base-url") + "properties/" + nextStep + '/' + id;
                } else {
                    return $("body").data("base-url") + "properties/" + nextStep + '?' + ret.join('&');
                }
            } else {
                return $("body").data("base-url") + "properties/";
            }
        };

        var property_url = function (step) {
            var id = $('input[name="listing[id]"]').val();

            if (id) {
                return createURI(step, id);
            } else {
                return createURI(step);
            }
        };

        var setIndexes = function (key, totalOfInputs) {
            var counter = 0;
            var index = 0;
            var elements = document.getElementsByClassName(key);

            for (var idx = 0; idx < elements.length; idx++) {
                if (elements[idx].nodeName !== 'DIV') {
                    if (elements[idx].name) {
                        elements[idx].name = elements[idx].name.replace('index', counter);
                    }

                    index++;

                    if (index % totalOfInputs === 0) {
                        counter++;
                    }
                }
            }

            return true;
        };

        var unmaskFields = function () {
            $('.currency').each(function (index, value) {
                $(this).val($(this).maskMoney('unmasked')[0]);
            });

            $('.area').each(function (index, input) {
                $(this).val(Utils.unmaskArea($(input).val()));
            });

            $('.percentage').each(function (index, input) {
                $(this).val($(this).maskMoney('unmasked')[0]);
            });

            $('.postmask-integer, .postmask-currency, .postmask-percentage, .postmask-money').each(function (index, value) {
                $(this).val($(this).val().replace(/[^\d.-]/g, ''));
            });
        };

        var showDetails = function(el) {
            var id = $(el).attr('data-id');

            $.ajax({
                url: $("body").data("base-url") + 'properties/getDetails',
                data: {id: id},
                beforeSend: function () {
                    $('.drawer').addClass('open');

                    $("#property-detail").LoadingOverlay("show",
                        {
                            image: $('body').attr('data-base-url') + "assets/img/loading.png",
                            imageAnimation: '2500ms rotate_left',
                            zIndex: 1002,
                            background: "rgba(255, 255, 255, 0.95)"
                        }
                    );
                },
                success: function (responseText) {
                    window.scrollTo(0, 0);
                    var data = JSON.parse(responseText);
                    fillDetails(data);
                }
            }).done(function (data) {
                initCarousel();
                $('#property-detail').LoadingOverlay("hide");
                window.scrollTo(0, 0);
            });
        };

        var fillDetails = function (data) {
            try {
                var listingDetail = $('#property-detail');
                var body = $('body');

                /*Property section*/
                var property = data.property;
                if(property.canEdit) {
                    $('#link-to-edit-page').removeClass('hide');
                    $('#link-to-edit-page').attr('href', body.attr('data-base-url') + 'properties/overview/' +  property.id);
                } else {
                    $('#link-to-edit-page').addClass('hide');
                    $('#link-to-edit-page').attr('href', body.attr('data-base-url') + 'properties');
                }

                var askingPrice = 'Price Not Disclosed';

                if (property.building_size_suites_parcels && property.building_size_suites_parcels.length > 0) {
                    property.building_size = property.building_size_suites_parcels;
                }

                if (property.listing_type.toLowerCase() === 'lease' && property.asking_price_psf) {
                    askingPrice = property.asking_price_psf;
                } else if (property.listing_type.toLowerCase() === 'sale' && property.asking_price) {
                    askingPrice = property.asking_price;
                } else if (Utils.contains(property.listing_type, 'sale') && Utils.contains(property.listing_type,'lease')) {
                    if(property.asking_price_psf) {
                        askingPrice = property.asking_price_psf;
                    } else if(property.asking_price) {
                        askingPrice = property.asking_price;
                    }
                }

                if(askingPrice === 'Price Not Disclosed' && property.building_price_suites_parcels) {
                    askingPrice = property.building_price_suites_parcels;
                }


                // Check whether notes and descriptions are provided
                if (property.description === null) {
                    property.description = 'No description provided.';
                }

                if (property.notes === null) {
                    property.notes = 'No sales notes provided.';
                }

                if (property.status) {
                    $('.property-status').find('p').html(unitDealStatus[property.status.toLowerCase()]);
                    $('.property-status').show();
                } else {
                    $('.property-status').find('p').html('');$('.property-status').find('p').html('');
                    $('.property-status').hide();
                }

                listingDetail.find('.content [data-ref=zoning_type]').html(property.zoning_type);
                listingDetail.find('.content [data-ref=property_class]').html(property.property_class);
                listingDetail.find('.content [data-ref=sale_type]').html(property.listing_type);
                listingDetail.find('.content [data-ref=land_size]').html(property.land_size);
                listingDetail.find('.content [data-ref=building_size]').html(property.building_size);
                listingDetail.find('.content [data-ref=n_stories]').html(property.no_stories);
                listingDetail.find('.content [data-ref=year_built]').html(property.year_built);
                listingDetail.find('.content [data-ref=business_name]').html(property.business_name);
                listingDetail.find('.content [data-ref=street_address]').text((property.street_address !== null ? property.street_address : 'Address Not Disclosed'));
                listingDetail.find('.content [data-ref=city]').text(property.city);
                listingDetail.find('.content [data-ref=state]').text(property.state);
                listingDetail.find('.content [data-ref=zipcode]').text(property.zipcode);
                listingDetail.find('.content [data-ref=date_listed]').text(property.listing_created);

                listingDetail.find('.content [data-ref=asking_price]').text(askingPrice);
                listingDetail.find('.content [data-ref=description]').html(property.description);
                listingDetail.find('.content [data-ref=notes]').html(property.notes);

                //Attachments
                if (property.attachments) {
                    listingDetail.find('.content [data-ref=attachments]').parent().show();

                    var html = "<ul>";
                    $(property.attachments).each(function (index, obj) {
                        if(obj.origin === 'BUILDOUT_DOCUMENTS') {
                            html += "<li>";
                            html += '<p><a href="' + obj.dir + '" class="tooltipped" data-position="bottom" data-tooltip="' + (obj.description ? obj.description : obj.dir) + '" target="_blank">' + (obj.title ? obj.title : obj.filename) + '</a></p>';
                            html += "</li>";
                        } else {
                            html += "<li>";
                            html += '<p><a href="' +  $('body').attr('data-cdn-url') + obj.dir + '" class="tooltipped" data-position="bottom" data-tooltip="' + (obj.description ? obj.description : obj.dir) + '" target="_blank">' + (obj.title ? obj.title : obj.filename) + '</a></p>';
                            html += "</li>";
                        }
                    });

                    html += "</ul>";
                    listingDetail.find('.content [data-ref=attachments]').html(html);
                    listingDetail.find('.content [data-ref=attachments]').find('.tooltipped').tooltip();
                } else {
                    listingDetail.find('.content [data-ref=attachments]').parent().hide();
                    listingDetail.find('.content [data-ref=attachments]').empty();
                }

                //Suites and parcels
                var wrapper = listingDetail.find('.content [data-ref=suites-parcels]');

                if (property.suites_parcels && property.suites_parcels.length > 0) {

                    // Determine the type of unit
                    var unit = property.suites_parcels_type.toString();

                    if (unit === 'SUITE') {
                        listingDetail
                            .find('.content [data-ref=suites-parcels-title]')
                            .text(property.suites_parcels.length === 1 ? 'Suite' : 'Suites');
                    } else if (unit === 'PARCEL') {
                        listingDetail
                            .find('.content [data-ref=suites-parcels-title]')
                            .text(property.suites_parcels.length === 1 ? 'Parcel' : 'Parcels');
                    }


                    // Clone the unit element and populate it with ref attributes
                    var ul = listingDetail.find('[data-ref=suites-parcels] ul');
                    var clone = ul.children('li[data-ref=unit-clone]').clone();

                    // Empty any pre-existing units
                    ul.find('li:not([data-ref])').remove();

                    $(property.suites_parcels).each(function (index, obj) {

                        var copy = clone.clone();

                        // Remove clone attributes
                        copy.removeAttr('data-ref').removeClass('hide');

                        // Assign the object to it's respective data reference point
                        copy.find('[data-ref=unit-title]').text(obj.name);
                        if(obj.description && obj.description.length > 0) {
                            copy.find('[data-ref=unit-description]').text(obj.description);
                        } else {
                            copy.find('[data-ref=unit-description]').prev().remove();
                            copy.find('[data-ref=unit-description]').remove();
                        }


                        if(obj.floor && obj.floor.length > 0) {
                            copy.find('[data-ref=unit-floor]').text(obj.floor);
                        } else {
                            copy.find('[data-ref=unit-floor]').prev().remove();
                            copy.find('[data-ref=unit-floor]').remove();
                        }

                        copy.find('[data-ref=unit-lease-rate]').text('$' + obj.lease_rate);
                        copy.find('[data-ref=unit-type-title]').text(unit.charAt(0).toUpperCase() + unit.slice(1).toLowerCase());
                        copy.find('[data-ref=unit-size]').text(obj.space_size);
                        copy.find('[data-ref=unit-dimension]').text(obj.dimension.toString() === 'SF' ? ' SF' : ' AC');
                        copy.find('[data-ref=unit-lease-type]').text(leaseTypes[obj.lease_type]);

                        var deal_status = unitDealStatus[obj.deal_status.toLowerCase()];

                        if(deal_status === 'Available') {
                            copy.find('[data-ref=unit-deal-status]').text(property.listing_type);
                        } else {
                            copy.find('[data-ref=unit-deal-status]').text(deal_status);
                        }

                        // Append the cloned unit to the list
                        ul.append(copy);
                    });

                    // Show the unit row
                    wrapper.removeClass('hide');

                    // Remove the clone
                    clone.remove();

                } else {
                    wrapper.addClass('hide');
                }

                listingDetail.find('.content [data-ref=parking]').text(property.parking);
                property.zoning = Utils.truncate(property.zoning_description, 500, 'Zoning Description', 'p');
                listingDetail.find('.content [data-ref=zoning_description]').text(property.zoning_description);
                listingDetail.find('.content [data-ref=apn]').text(property.parcel_id_apn);
                listingDetail.find('.content [data-ref=main_broker]').text(property.main_broker);
                listingDetail.find('.content [data-ref=secondary_brokers]').text(property.secondary_brokers);

                // Hide empty rows
                $('.property dl dd').each(function () {
                    if ($(this).text() === '' || $(this).text() === '0' || $(this).text() === '0 acres' || $(this).text() === '0 SF') {
                        $(this).addClass('hide');
                        $(this).prev('dt').addClass('hide');
                    } else {
                        $(this).removeClass('hide');
                        $(this).prev('dt').removeClass('hide');
                    }
                });

                /*Images*/
                if (property.map_image_url.length > 0) {
                    listingDetail.find('.content [data-ref=map_image_url]').css('background-image', 'url(' + Utils.imageUrl(property.map_image_url) + ')');
                } else {
                    var map_image = MapController.Listings.getImage(property.street_address, property.city, property.state, property.id);

                    if (map_image && map_image.length > 0) {
                        listingDetail.find('.content [data-ref=map_image_url]').css('background-image', 'url(' + map_image + ')');
                    } else {
                        listingDetail.find('.content [data-ref=map_image_url]').css('background-image', '');
                    }
                }

                var gallery = getGallery();

                if (property.uploaded_images && property.uploaded_images.length > 0) {
                    var uploaded_images = property.uploaded_images.sort(function (obj1, obj2) {
                        return obj1.index - obj2.index;
                    });

                    $.each(uploaded_images, function (index, value) {
                        if (value.path) {
                            gallery.append('<a class="carousel-item"><img class="materialboxed" src="' + Utils.imageUrl(value.path) + '"></a>');
                        }
                    });
                } else {
                    if (property.property_image_url && property.property_image_url.length > 0) {
                        gallery.append('<a class="carousel-item"><img class="materialboxed" src="' + Utils.imageUrl(property.property_image_url) + '"></a>');
                    } else {
                        gallery.append('<a class="carousel-item"><img class="materialboxed" src="' + $('body').attr('data-base-url') + 'assets/img/no-photo-available.png"></a>');
                    }
                }

                /*Steps*/
                var previousIndex = parseInt(data.index) - 1;
                var previousButton = listingDetail.find('a#previous-listing');
                previousButton.attr('data-index', previousIndex);

                if (previousIndex < 0) {
                    previousButton.addClass('disabled');
                } else {
                    previousButton.removeClass('disabled');
                }

                var nextIndex = parseInt(data.index) + 1;
                var nextButton = listingDetail.find('a#next-listing');
                nextButton.attr('data-index', nextIndex);

                var totalListings = parseInt($('[data-ref=total_of_listings]').html());

                if (nextIndex >= totalListings) {
                    nextButton.addClass('disabled');
                } else {
                    nextButton.removeClass('disabled');
                }

            } catch (err) {
                console.log('It is not possible to load the property at the moment.');
                console.log(err);
            }
        };

        var initCarousel = function () {
            $('.carousel.carousel-slider').carousel({fullWidth: true});

            // move next carousel
            $('.moveNextCarousel').click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                $('.carousel.carousel-slider').carousel('next');
            });

            // move prev carousel
            $('.movePrevCarousel').click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                $('.carousel.carousel-slider').carousel('prev');
            });

            $('.materialboxed').materialbox();
        };

        var getGallery = function () {
            var gallery = $('#property-detail .content [data-ref=gallery]');

            gallery.find('.carousel-item').remove();

            if (gallery.hasClass('initialized')) {
                gallery.removeClass('initialized');
            }
            return gallery;
        };

        var closeDetails = function () {
            $('.drawer').removeClass('open');
            window.scrollTo(0, 0);
            history.pushState("", document.title, window.location.pathname + window.location.search);
        };


        initialize();

        if (window.PropertiesController === undefined) {
            window.PropertiesController = {};
        }

        window.PropertiesController = {
            duplicateProperty: duplicateProperty,
            createURI: createURI,
            showDetails: showDetails,
            closeDetails: closeDetails
        };
    }
});

$(document).ready(function () {
    dragula([document.querySelector('#image-area'), document.querySelector('#image-area')])
        .on('drop', function (el) {
            FileController.recountImages();
        });

    FileController.initialize();
});

/*Callback function called by the Google Maps API*/
function initializePropertiesMap() {
    MapController.Properties.init();
    MapController.Properties.setSelectedArea();
}


/*Callback function called by the Google Maps API*/
function initializePropertiesPinMap() {
    MapController.Properties.init();
    MapController.Properties.setSelectedPin();
}


